/**
 * @generated SignedSource<<bbd91acea292f6b53a6ba29bcd9bdd91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PresentationVideoPlayerNew_presentation$data = {
  readonly videoSourceUrl: string | null | undefined;
  readonly " $fragmentType": "PresentationVideoPlayerNew_presentation";
};
export type PresentationVideoPlayerNew_presentation$key = {
  readonly " $data"?: PresentationVideoPlayerNew_presentation$data;
  readonly " $fragmentSpreads": FragmentRefs<"PresentationVideoPlayerNew_presentation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PresentationVideoPlayerNew_presentation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoSourceUrl",
      "storageKey": null
    }
  ],
  "type": "Presentation",
  "abstractKey": null
};

(node as any).hash = "3a66bb8e3a4d24b9ad7673c1969cef1e";

export default node;
